module.exports = __webpack_public_path__ + "static/kinds-of-refinancing-cc301455a4ca2625ce4cff2c7526dd25.png";